import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Layout, Space, Divider as AntDivider } from 'antd';
import Color from '../../../enums/color';
import Avatar from '../../shared/Avatar';
import Logo from './Logo';
import Logout from './Logout';
import { automationIds } from '../../../constants/automationIds';
import Route from '../../../enums/route';
import useGlobalState from '../../../hooks/useGlobalState';
import store from '../../../store';
import Notifications from '../../shared/notifications/Notifications';
import useAccessPolicy from '../../../hooks/useAccessPolicy';
import AccessPolicy from '../../../enums/accessPolicy';
import ContentHandler from '../../shared/ContentHandler';
const StyledHeader = styled(Layout.Header) `
  position: fixed;
  width: 100%;
  background: ${Color.CobaltBlue};
  padding: 16px 32px;
  line-height: 30px;
  box-shadow: 0 3px 6px 0 ${Color.BlackOpacity57};
  z-index: 3;
`;
const StyledDiv = styled.div `
  display: flex;
  float: right;
`;
const Divider = styled(AntDivider) `
  height: 32px;
  border-color: ${Color.TuftsBlue};
  border-width: 2px;
`;
const Header = () => {
    const { currentUser } = useGlobalState(store.auth);
    const canViewNotifications = useAccessPolicy({ id: AccessPolicy.ViewNotifications });
    return (<StyledHeader>
      <Logo />
      <StyledDiv>
        <Space size={20}>
          <ContentHandler shouldDisplayContent={canViewNotifications} render={Notifications}/>
          <Divider type='vertical'/>
          <Link to={Route.Profile} data-automation-id={automationIds.NAV_LINK.PROFILE}>
            <Avatar names={[currentUser.lastName, currentUser.firstName]}/>
          </Link>
          <Logout />
        </Space>
      </StyledDiv>
    </StyledHeader>);
};
export default Header;
